const state = {
    user: {},
    user_permissions: [],
    user_colour: "",
    user_initals: "",
    settings: [],
    avatar: [],

    // user profile page
    timezones: [],
    token: "",
    browserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
}

const getters = {
    user: state => {
        return state.user
    },
    settings: state => {
        return state.settings
    },
    getPermissionByName: state => name => {
        if (state.user_permissions) {
            let permission = state.user_permissions.find(permission => {
                return permission.name === name
            })
            if (permission) {
                return permission
            } else {
                return 0
            }
        } else {
            return 0
        }
    },
    user_colour: state => {
        return state.user_colour
    },
    user_initals: state => {
        return state.user_initals
    },

    timezones: state => {
        return state.timezones.filter(timezone => timezone.includes('Australia'))
    },
    browserTimezone: state => {
        return state.browserTimezone
    },
    token: state => {
        return state.token
    }
}

const mutations = {
    saveUser(state, user) {
        state.user = user;
        state.user_permissions = user.permissions;
        state.user_colour = setUserColour(user)
        state.user_initals = getInitials(user.full_name)
    },
    setSettings(state, settings) {
        state.settings = settings;
    },

    // user profile page
    setUser(state, user) {
        state.user = user;
    },
    setTimezones(state, timezones) {
        state.timezones = timezones;
    },
    setToken(state, token) {
        state.token = token;
    },
};

const actions = {
    saveUser({ commit }, payload) {
        return axios
            .get("/api/v2/me?include=roles&permissions", {
                headers: { Authorization: "Bearer " + payload }
            })
            .then(res => {
                commit("saveUser", res.data);
            });
    },
    setSettings({ dispatch, commit, state }, data) {
        commit('setSettings', data)
    },

    // user profile page
    setUser({ dispatch, commit, state }, data) {
        commit('setUser', data)
    },
    setTimezones({ dispatch, commit, state }, data) {
        commit('setTimezones', data)
    },
    setToken({ dispatch, commit, state }, data) {
        commit('setToken', data)
    },
};

function setUserColour(user, s = 30, l = 50) {
    var hash = 0
    for (var i = 0; i < user.full_name.length; i++) {
        hash = user.full_name.charCodeAt(i) + ((hash << 5) - hash)
    }

    var h = hash % 360
    return "hsl(" + h + ", " + s + "%, " + l + "%)"
};

function getInitials(name) {
    return name.split(" ").map(e => e.charAt(0)).join("").toUpperCase()
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
